import { render, staticRenderFns } from "./BlockType28.vue?vue&type=template&id=e2ca29d6&scoped=true"
import script from "./BlockType28.vue?vue&type=script&lang=ts"
export * from "./BlockType28.vue?vue&type=script&lang=ts"
import style0 from "./BlockType28.vue?vue&type=style&index=0&id=e2ca29d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../src-custom-solutions/president-election/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2ca29d6",
  null
  
)

export default component.exports